<template>
  <available-section section="prodoctorov-integrations">
    <main class="integration-prodoctorov">
      <div class="integration-prodoctorov__container">
        <button-back />
        <h1 class="integration-prodoctorov__title">Настройка интеграции</h1>
        <form
          v-if="isLoaded"
          class="integration-prodoctorov__connection"
          v-on:submit.prevent="onSubmit"
        >
          <dl class="integration-prodoctorov__definition">
            <dt class="integration-prodoctorov__definition__label">Название клиники</dt>
            <dd class="integration-prodoctorov__definition__count">{{ clinicName }}</dd>
          </dl>
          <input-text
            pattern="[a-z0-9]{64}"
            required
            maxlength="64"
            title="Токен"
            v-model="integrationToken"
          />
          <button
            v-if="integrationExists"
            class="integration-prodoctorov__button"
            type="submit"
          >
            Изменить
          </button>
          <button
            v-else
            class="integration-prodoctorov__button"
            type="submit"
          >
            Включить интеграцию
          </button>
        </form>
        <support-contacts class="integration-prodoctorov__contacts" title="Если у вас возникли вопросы, свяжитесь с нами:" />
      </div>
    </main>
  </available-section>
</template>
<script>

import clipboardMixin from '@/mixins/clipboardMixin';
import notifierMixin from '@/mixins/notifierMixin';
import SupportContacts from '@/components/SupportContacts.vue';
import AvailableSection from '@/views/ClinicPanel/AvailableSection.vue';
import InputText from '@/components/InputText.vue';
import ButtonBack from '@/components/ButtonBack.vue';

/**
 * @description Компонент интеграции с Prodoctorov.
 * @type {Vue}
 */
export default {
  components: {
    ButtonBack,
    AvailableSection,
    InputText,
    SupportContacts,
  },
  computed: {
    /**
     * @description Имеет интеграцию.
     * @type {boolean}
     */
    hasIntegration() {
      return this.integrationKey !== '';
    },
  },
  created() {
    this.fetchIntegration();
  },
  data() {
    return {
      /**
       * @description Название клиники.
       * @type {string}
       */
      clinicName: '',
      /**
       * @description Данные загружены.
       * @type {boolean}
       */
      isLoaded: false,
      /**
       * @description Токен интеграции.
       * @type {string}
       */
      integrationToken: '',
      /**
       * @description Наличие интеграции.
       * @type {boolean}
       */
      integrationExists: false,
    };
  },
  methods: {
    /**
     * @description Получить ключ интеграции.
     */
    fetchIntegration() {
      const onFail = ({ title }) => { this.notifyFail(title); };
      const onSuccess = (response) => {
        this.clinicName = response.name;
        this.integrationToken = response.token;
        this.integrationExists = response.exists;
      };
      this
        .$aggregatorIntegrationGateway
        .getProdoctorov()
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isLoaded = true; });
    },
    /**
     * @description Сформировать запрос.
     * @returns {any}
     */
    makeRequest() {
      return { token: this.integrationToken };
    },
    /**
     * @description Обработать подключение к интеграции.
     * @returns {void}
     */
    submitConnect() {
      const onFail = ({ title }) => { this.notifyFail(title); };
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
        this.fetchIntegration();
      };
      this
        .$aggregatorIntegrationGateway
        .createProdoctorov(this.makeRequest())
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать изменение интеграции.
     * @returns {void}
     */
    editConnect() {
      const onFail = ({ title }) => { this.notifyFail(title); };
      const onSuccess = ({ message }) => { this.notifySuccess(message); };
      this
        .$aggregatorIntegrationGateway
        .editProdoctorov(this.makeRequest())
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      if (this.integrationExists) {
        this.editConnect();
      } else {
        this.submitConnect();
      }
    },
  },
  mixins: [
    clipboardMixin,
    notifierMixin,
  ],
  name: 'ClinicPanelIntegrationProdoctorov',
};
</script>
<style lang="scss">
@use "@/scss/copy-icon";
@use "@/scss/buttons";

.integration-prodoctorov {
  width: 100%;
  height: 100%;
  overflow: scroll;
  &__container {
    padding: 38px 20px 200px 23px;
  }
  &__title {
    font-weight: 600;
    font-size: 38px;
    line-height: 46px;
    color: #000000;
    margin: 0 0 22px 0;
  }
  &__subtitle {
    display: block !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    a:hover {
      text-decoration: none;
    }
  }
  &__connection {
    background-color: var(--section-background-color);
    padding: 40px 50px 35px 40px;
    margin: 46px 0 0 0;
  }
  &__definition {
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--unfocus-color);
    }
    &__count {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #192A3E;
      margin: 10px 0 30px 0;
    }
    &__key {
      display: flex;
      align-items: center;
      background-color: var(--primary-background-color);
      border: 1px solid var(--border-color);
      border-radius: 4px;
      padding: 12px 45px 12px 20px;
      position: relative;
      font-size: 21px;
      width: 100%;
    }
    &__copy {
      @extend %copy-icon;
      position: absolute;
      width: 24px;
      height: 24px;
      right: 20px;
    }
  }
  &__button {
    @include buttons.btn-blue(244px, 48px, 16px);
    max-width: 100%;
    margin: 40px 0 0 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__control {
    border-top: 1px solid #C2CFE0;
    background-color: var(--section-background-color);
    padding: 30px 50px 60px 40px;
  }
  &__table {
    counter-reset: counterEmployees;
    background: #FFFFFF;
    margin: 35px 0 0 0;
    &__head,
    &__row {
      align-items: center;
      cursor: pointer;
      display: grid;
      font-size: 14px;
      grid-template-columns: 40px 1fr 138px;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489E0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #EAEFF3;
      padding: 12px 0;
      &:hover {
        background: #EAEFF3;
      }
    }
    &__cell {
      padding: 0 8px;
      position: relative;
      &.number:after {
        counter-increment: counterEmployees;
        content: counter(counterEmployees);
      }
      &.align {
        text-align: center;
      }
    }
  }
  &__checkbox {
    position: absolute;
    z-index: -1;
    opacity: 0;
    &:checked + label:before {
      background: rgba(4, 137, 224, 0.18);
      border: 1px solid #0489E0;
    }
    &:checked + label:after {
      left: 16px;
      background: #0489E0;
    }
  }
  &__checkbox + label {
  position: relative;
  padding: 0 0 0 38px;
  cursor: pointer;
  }
  &__checkbox + label:before {
    content: '';
    position: absolute;
    top: -4px;
    left: 0;
    width: 38px;
    height: 24px;
    border-radius: 15px;
    background: #EAEFF3;
    border: 1px solid #C2CFE0;
    transition: .2s;
  }
  &__checkbox + label:after {
    content: '';
    position: absolute;
    top: -2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: #90A0B7;
    transition: .2s;
  }
  &__contacts {
    margin: 46px 0 0 0;
  }
  &__qr-code {
    display: block;
    margin-top: 10px;
  }
}

@media screen and (max-width: 1240px) {
  .integration {
    &__container {
      width: 100%;
      padding: 45px 20px 145px;
    }
  }
}
@media screen and (max-width: 640px) {
  .integration {
    &__container {
      padding: 45px 10px 145px;
    }
  }
}
@media screen and (max-width: 600px) {
  .integration {
    &__table {
      &__head {
        display: none;
      }
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 0 0 20px 0;
      }
      &__cell {
        display: flex;
        justify-content: space-between;
        text-align: right;
        font-size: 12px;
      }
      &__cell:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
        font-size: 10px;
        text-align: left;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .integration {
    &__connection {
      background-color: transparent;
      padding: 0 0 20px 0;
    }
    &__control {
      padding: 20px 0 0 0;
      background-color: transparent;
    }
  }
}
</style>
